import HarvestGraph from './HarvestGraph';

export default HarvestGraph;
